import request from '@/common/request'

// Preferências do usuário logado. Ficam no ERP, por usuário, para valer em qualquer computador: o logout limpa o
// armazenamento do navegador.
export const buscarPreferenciasDoUsuario = (): Promise<Record<string, string>> =>
	request.get(`/usuarios/me/preferencias`)

export const gravarPreferenciaDoUsuario = (chave: string, valor: string): Promise<void> =>
	request.put(`/usuarios/me/preferencias/${encodeURIComponent(chave)}`, { valor })
